import { gql } from 'graphql.macro';

export const createMaterialMacroTemplate = gql`
    mutation createMaterialMacro($name: String!) {
        createMaterialMacro(name: $name) {
            _id
            name
            materials {
                _id
                material {
                    _id
                    materialCode
                    description
                    vat
                    batchInventoryManagement
                    batches {
                        batchNumber
                        quantity
                        fullBatchQuantity
                        createdOn
                        closed
                        closedDate
                    }
                }
            }
        }
    }
`;

export const modifyMaterialMacroTemplate = gql`
    mutation modifyMaterialMacro($_id: String!, $name: String!) {
        modifyMaterialMacro(_id: $_id, name: $name) {
            _id
            name
            materials {
                _id
                material {
                    _id
                    materialCode
                    description
                    vat
                    batchInventoryManagement
                    batches {
                        batchNumber
                        quantity
                        fullBatchQuantity
                        createdOn
                        closed
                        closedDate
                    }
                }
            }
        }
    }
`;

export const deleteMaterialMacroTemplate = gql`
    mutation deleteMaterialMacro($materialMacroId: String!) {
        deleteMaterialMacro(materialMacroId: $materialMacroId)
    }
`;

export const addMaterialToMacroTemplate = gql`
    mutation addMaterialToMacro($materialMacroId: String!, $materialId: String!) {
        addMaterialToMacro(materialMacroId: $materialMacroId, materialId: $materialId) {
            _id
            name
            materials {
                _id
                material {
                    _id
                    materialCode
                    description
                    vat
                    batchInventoryManagement
                    batches {
                        batchNumber
                        quantity
                        fullBatchQuantity
                        createdOn
                        closed
                        closedDate
                    }
                }
            }
        }
    }
`;

export const deleteMaterialMacroRowTemplate = gql`
    mutation deleteMaterialMacroRow($materialMacroId: String!, $materialId: String!) {
        deleteMaterialMacroRow(materialMacroId: $materialMacroId, materialId: $materialId) {
            _id
            name
            materials {
                _id
                material {
                    _id
                    materialCode
                    description
                    vat
                    batchInventoryManagement
                    batches {
                        batchNumber
                        quantity
                        fullBatchQuantity
                        createdOn
                        closed
                        closedDate
                    }
                }
            }
        }
    }
`;
